export default {
  arrives: 'Arrivo',
  journeyDuration: 'Durata del viaggio',
}
